<template>
    <report-usages-list show-no-energy  :tokenUid="token?.uid"/>
</template>

<script>
import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: {ReportUsagesList},

  computed: {
    token() {
      return this.$parent.token ?? null
    },


  },
}
</script>

<style lang="scss">

</style>
